import Button from "../Button";
import NavigationMenu from "../NavigationMenu";
import "./styles.css";

const DashboardPage = ({ title, createIcon, children, onCreate }) => {
  return (
    <div className="page__wrapper">
      <NavigationMenu />
      <div className="page__content--container">
        <div className="page__header--container">
          <div className="page__header--title">{title} Dashboard</div>
          {onCreate && (
            <Button onClick={onCreate} title={`Create ${title}`} icon={createIcon} />
          )}
        </div>

        <main>{children}</main>
      </div>
    </div>
  )
};
  
  export default DashboardPage;